<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useErrorStateStore } from "@/stores/errorState";
import TgButton from "@/components/common/TgButton.vue";
import ErrorPage from "./ErrorPage.vue";

export default defineComponent({
  name: "App401Error",
  components: { ErrorPage, TgButton },
  setup() {
    const router = useRouter();
    const errorState = useErrorStateStore();

    function goBack(): void {
      errorState.clearFault();
      router.push({ name: "login" });
    }

    onMounted(() => {
      setTimeout(() => {
        errorState.clearFault();
        router.push({ name: "login" });
      }, 10000);
    });

    return { goBack };
  },
});
</script>
<template>
  <ErrorPage>
    <template #title>Login required</template>
    <template #message>
      You need to log in to access this page. If you think you've reached this page in error, please let us know!
    </template>
    <template #controls>
      <TgButton class="m-4" :is-rounded="true" color="primary" @click="goBack">Log in</TgButton>
    </template>
  </ErrorPage>
</template>
